import { render, staticRenderFns } from "./ISurvey.vue?vue&type=template&id=83b61bee&"
import script from "./ISurvey.vue?vue&type=script&lang=ts&"
export * from "./ISurvey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports